import { withSvgIcon } from './withSvgIcon';

export const RequestIcon = withSvgIcon(
  <>
    <path
      d="M13.5 17.5H7.64093C7.32308 17.5 7.16415 17.5 7.01529 17.5477C6.86643 17.5954 6.7371 17.6878 6.47845 17.8725L3.5 20V7.5C3.5 6.55719 3.5 6.08579 3.79289 5.79289C4.08579 5.5 4.55719 5.5 5.5 5.5H18C18.9428 5.5 19.4142 5.5 19.7071 5.79289C20 6.08579 20 6.55719 20 7.5V12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M7 9.5L15 9.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M7 13L12 13" stroke="currentColor" strokeWidth="1.5" />
    <path d="M16 17H22" stroke="currentColor" strokeWidth="1.5" />
    <path d="M19 20V14" stroke="currentColor" strokeWidth="1.5" />
  </>,
  { viewBox: '0 0 24 24' },
);
